const isMatchFieldValue = (value) => value !== null && typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 1 && typeof value.match === "string";
const hasMatchFieldCycle = (targetPath, sourcePath, rules) => {
  const dependencies = /* @__PURE__ */ new Map();
  rules.filter((rule) => rule.type === "value").forEach((rule) => {
    rule.instructions.forEach((instruction) => {
      const action = instruction.action?.[0];
      if (action?.path && isMatchFieldValue(action.value)) {
        dependencies.set(action.path, [
          ...dependencies.get(action.path) ?? [],
          action.value.match
        ]);
      }
    });
  });
  const visit = (path, ancestors) => {
    if (ancestors.has(path)) return true;
    const nextAncestors = /* @__PURE__ */ new Set([...ancestors, path]);
    return (dependencies.get(path) ?? []).some(
      (source) => visit(source, nextAncestors)
    );
  };
  return visit(sourcePath, /* @__PURE__ */ new Set([targetPath]));
};
export {
  hasMatchFieldCycle,
  isMatchFieldValue
};
